import PropTypes from 'prop-types';

import { BookingContext, bookingClassNameModifier } from '../booking.context';
import { PartnerPhoto } from './partner-photo';
import styles from './BookingPartner.scss';

export const BookingPartner = ({
  partnerName,
  partnerTitle,
  photoUrl = null,
  hidePartnerPrefix = false,
  hidePartnerNameUnderline = false,
}) => (
  <BookingContext.Consumer>
    {(context) => (
      <div
        className={styles[`${bookingClassNameModifier(context)}BookingReview__partner`]}
        data-testid="appointmentPartner"
      >
        <PartnerPhoto src={photoUrl} alt={partnerName} partnerTitle={partnerTitle} />
        <div className={styles.BookingReview__partner_info}>
          <h3
            className={
              hidePartnerNameUnderline
                ? styles.BookingReview__partner_name_without_underline
                : styles.BookingReview__partner_name
            }
          >
            {partnerName}
          </h3>
          <p data-testid="partner_position" className={styles.BookingReview__partner_position}>
            {hidePartnerPrefix ? partnerTitle : `Partner & ${partnerTitle}`}
          </p>
        </div>
      </div>
    )}
  </BookingContext.Consumer>
);

BookingPartner.propTypes = {
  partnerName: PropTypes.string.isRequired,
  photoUrl: PropTypes.string,
  partnerTitle: PropTypes.string.isRequired,
  hidePartnerPrefix: PropTypes.bool,
  hidePartnerNameUnderline: PropTypes.bool,
};
